<template>
  <v-container fluid v-if="files">
    <v-col align="start">
      <v-btn color="#008B52" class="history-button" @click="setErrorFalse">
        Archivos Subidos
      </v-btn>
      <v-btn color="error" @click="setErrorTrue"> Errores </v-btn>
    </v-col>

    <v-row>
      <v-col cols="3" align="start">
        <v-select
          :items="getFileNamesByContent"
          v-model="filters['format']"
          label="Archivo"
          outlined
          dense
        >
          <template v-slot:append>
            <v-icon
              @mouseup.stop
              aria-hidden="false"
              v-if="filters['format'] !== ''"
              @click.prevent.stop="clearFilter('format')"
              dense
            >
              mdi-close
            </v-icon>
            <v-icon> mdi mdi-menu-down </v-icon>
          </template>
        </v-select>
      </v-col>
      <v-col cols="3" align="start">
        <v-select
          :items="getContractNamesByContent"
          v-model="filters['contract_name']"
          label="Contrato"
          outlined
          dense
        >
          <template v-slot:append>
            <v-icon
              @mouseup.stop
              aria-hidden="false"
              v-if="filters['contract_name'] !== ''"
              @click.prevent.stop="clearFilter('contract_name')"
              dense
            >
              mdi-close
            </v-icon>
            <v-icon> mdi mdi-menu-down </v-icon>
          </template>
        </v-select>
      </v-col>
      <v-col cols="3" align="start">
        <v-select
          :items="getMonthsByContent"
          v-model="filters['month']"
          label="Periodo"
          outlined
          dense
        >
          <template v-slot:append>
            <v-icon
              @mouseup.stop
              aria-hidden="false"
              v-if="filters['month'] !== ''"
              @click.prevent.stop="clearFilter('month')"
              dense
            >
              mdi-close
            </v-icon>
            <v-icon> mdi mdi-menu-down </v-icon>
          </template>
        </v-select>
      </v-col>
      <v-col cols="2" align="start">
        <v-text-field
          v-model="filters['year']"
          label="Año"
          single-line
          outlined
          hide-details
          dense
        ></v-text-field>
      </v-col>
    </v-row>

    <v-col>
      <v-data-table
        height="100%"
        :page="page"
        @pagination="fetchDataIfNeccesary"
        :headers="getHeadersByContent"
        :items="getItemsByContent"
        :items-per-page="10"
        :loading="loading"
        loading-text="Cargando... por favor espere"
        class="elevation-1"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 15],
          showFirstLastPage: false,
        }"
      >
        <template v-slot:top>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card min-height="200px">
              <v-card-title class="text-h6"> Eliminar Archivo </v-card-title>
              <v-divider></v-divider>
              <container class="modalContainer">
                <p>¿Estás seguro que deseas eliminar el archivo del portal?</p>
                <button
                  @click="deleteFileConfirm"
                  class="button uploadButton firstButton"
                >
                  Aceptar
                </button>
                <button @click="closeModal" class="button uploadAgainButton">
                  Cancelar
                </button>
              </container>
            </v-card>
          </v-dialog>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon large @click="showModal(item)" color="red">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-col>
  </v-container>
</template>

<script>
import {
  getHistoryLogs,
  getErrorsLog,
  deleteFileFromBuckets,
} from '../utils/serverRequests';
import {
  historyHeaders,
  errorHeaders,
  months,
  fileNames,
  contractNames,
} from '../utils/tableContent';
export default {
  data() {
    return {
      historyLogLastEvaluatedKey: false,
      errorsLogLastEvaluatedKey: false,
      currentFileToDelete: null,
      firstFetchHistory: true,
      firstFetchError: true,
      dialogDelete: false,
      showErrors: false,
      loading: true,
      errors: [],
      files: [],
      page: 1,
      filters: {
        format: '',
        contract_name: '',
        month: '',
        year: '',
      },
    };
  },
  name: 'History',
  computed: {
    getHeadersByContent() {
      if (this.showErrors) {
        return errorHeaders;
      }
      return historyHeaders;
    },
    getItemsByContent() {
      if (this.showErrors) {
        return this.errors;
      }
      return this.filteredLogs;
    },
    getMonthsByContent() {
      return months;
    },
    getFileNamesByContent() {
      return fileNames;
    },
    getContractNamesByContent() {
      return contractNames;
    },
    filteredLogs() {
      return this.files.filter((log) => {
        return Object.keys(this.filters).every((f) => {
          return (
            this.filters[f] == '' ||
            log[f]?.toLowerCase().includes(this.filters[f]?.toLowerCase())
          );
        });
      });
    },
  },
  created() {
    this.setHistoryLogs();
  },
  watch: {
    dialogDelete(val) {
      val || this.closeModal();
    },
  },
  methods: {
    clearFilter(currentFilter) {
      this.filters[currentFilter] = '';
    },
    showModal(file) {
      this.currentFileToDelete = file;
      this.dialogDelete = true;
    },

    deleteFileConfirm() {
      const file = this.currentFileToDelete;
      deleteFileFromBuckets(file, this.$store.state.jwt).then((response) => {
        if (response.data.deleted) {
          let files = this.files;
          files.splice(
            files.findIndex((item) => file._id === item._id),
            1,
          );
          this.files = files;
        }
      });
      this.closeModal();
    },

    closeModal() {
      this.dialogDelete = false;
      this.currentFileToDelete = null;
    },

    fetchDataIfNeccesary(event) {
      const { itemsLength, itemsPerPage, page } = event;
      if (!!this.files.length && page * itemsPerPage >= itemsLength) {
        if (!this.showErrors) {
          this.setHistoryLogs();
        }
      }
      if (!!this.errors.length && page * itemsPerPage >= itemsLength) {
        if (this.showErrors) {
          this.setErrorsLog();
        }
      }
      this.page = event.page;
    },
    setErrorTrue() {
      this.page = 1;
      if (!!!this.errors.length) {
        this.setErrorsLog();
      }
      this.showErrors = true;
    },
    setErrorFalse() {
      this.page = 1;
      this.showErrors = false;
    },
    async setHistoryLogs() {
      let params = false;
      if (this.historyLogLastEvaluatedKey) {
        params = {
          file_type: this.historyLogLastEvaluatedKey.file_type,
          _id: this.historyLogLastEvaluatedKey._id,
        };
      }
      if (this.firstFetchHistory || !!this.historyLogLastEvaluatedKey) {
        this.loading = true;
        getHistoryLogs(params, this.$store.state.jwt).then((response) => {
          this.loading = false;
          this.firstFetchHistory = false;
          if (response.data.logs.LastEvaluatedKey) {
            const { file_type, _id } = response.data.logs.LastEvaluatedKey;
            this.historyLogLastEvaluatedKey = {
              file_type,
              _id,
            };
          } else {
            this.historyLogLastEvaluatedKey = null;
          }
          response.data.logs.Items.map((file) => {
            const reg = /^([\w ]+)[-‐]{1}.*\.xlsx$/;
            const match = file.filename.match(reg);
            var options = { year: 'numeric', month: 'short', day: 'numeric' };
            file.year = file.year.toString();
            this.files.push({
              ...file,
              date: new Date(file.date).toLocaleDateString('es-ES', options),
              updateDate: file.updateDate
                ? new Date(file.updateDate).toLocaleDateString('es-ES', options)
                : 'N/A',
              format: match[1].toUpperCase(),
              month: new Intl.DateTimeFormat('es-ES', { month: 'long' })
                .format(new Date(`${file.period}`))
                .toUpperCase(),
            });
          });
        });
      }
    },
    async setErrorsLog() {
      let params = false;
      if (this.errorsLogLastEvaluatedKey) {
        params = {
          file_type: this.errorsLogLastEvaluatedKey.file_type,
          _id: this.errorsLogLastEvaluatedKey._id,
        };
      }
      if (this.firstFetchError || !!this.errorsLogLastEvaluatedKey) {
        this.loading = true;
        getErrorsLog(params, this.$store.state.jwt).then((response) => {
          this.loading = false;
          this.firstFetchError = false;
          if (response.data.LastEvaluatedKey) {
            const { file_type, _id } = response.data.LastEvaluatedKey;
            this.errorsLogLastEvaluatedKey = {
              file_type,
              _id,
            };
          } else {
            this.errorsLogLastEvaluatedKey = null;
          }
          response.data.errors.map((error) => {
            delete error.message;
            var options = { year: 'numeric', month: 'short', day: 'numeric' };
            const dateO = new Date(error.date);
            this.errors.push({
              ...error,
              date: dateO.toLocaleDateString('es-ES', options),
            });
          });
        });
      }
    },
  },
};
</script>
<style scoped>
.history-button {
  color: white;
  margin-right: 20px;
}
.button {
  width: 40%;
  min-width: 95px;
  height: 40px;
  min-height: auto;
  margin: 0 0px;
  transition: transform 0.3s;
  border-radius: 7px;
}
.uploadButton {
  border: 2px solid #008b52;
  color: #008b52;
}
.uploadAgainButton {
  border: 2px solid red;
  color: red;
}
.firstButton {
  margin-right: 5px;
}
.modalContainer {
  padding: 5px;
}
div.v-input {
  padding: 10px 16px;
}
</style>

